import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableLoginSuccess = Loadable({
  loader: function loader() {
    return import('../LoginSuccess.jsx');
  },
  loading: ComponentLoading
});
export default LoadableLoginSuccess;